export default {
  /**
   * Returns TRUE if the first specified array contains all elements
   * from the second one. FALSE otherwise.
   *
   * @param {array} superset
   * @param {array} subset
   *
   * @returns {boolean}
   */
  arrayContainsArray(superset, subset) {
    if (subset.length === 0) {
      return false;
    }
    return subset.every((value) => superset.includes(value));
  },

  arrayRemoveValues(arr, values) {
    const result = Array.from(arr);
    return result.filter((ele) => !values.includes(ele));
  },
  arrayRetainsValues(arr, values) {
    const result = Array.from(arr);
    return result.filter((ele) => values.includes(ele));
  },
  arrayRetainsIdx(arr, values) {
    return arr.filter((ele) => values.includes(ele.id));
  },
};

export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
  );
}
